<p><b>С иконкой и текстом</b></p>
<div class="card">
  <pa-table
    [columns]="iconTextColumns"
    [data]="iconTextData"
    [pagination]="pagination"
  >
  </pa-table>
</div>

<p><b>Обычный</b></p>
<div class="card">
  <p-table [value]="products" [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template #header>
      <tr>
        <th>#</th>
        <th>Код</th>
        <th>Название</th>
        <th>Категория</th>
        <th>Количество</th>
      </tr>
    </ng-template>
    <ng-template #body let-product>
      <tr>
        <td>{{ product.id }}</td>
        <td>{{ product.code }}</td>
        <td>{{ product.name }}</td>
        <td>{{ product.category }}</td>
        <td>{{ product.quantity }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p><b>Зебра</b></p>
<div class="card">
  <p-table stripedRows [value]="products" [tableStyle]="{ 'min-width': '50rem' }">
    <ng-template #header>
      <tr>
        <th>#</th>
        <th>Код</th>
        <th>Название</th>
        <th>Категория</th>
        <th>Количество</th>
      </tr>
    </ng-template>
    <ng-template #body let-product>
      <tr>
        <td>{{ product.id }}</td>
        <td>{{ product.code }}</td>
        <td>{{ product.name }}</td>
        <td>{{ product.category }}</td>
        <td>{{ product.quantity }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p><b>Адаптивная таблица</b></p>
<div class="card">
  <div class="filter-bar">
    <app-filter-bar
      [config]="filterData"
      [showAddButton]="false"
      (filterClick)="openFilterPanel()"
    >
    </app-filter-bar>
  </div>

  <pa-table [columns]="columns" [data]="products" [pagination]="pagination"> </pa-table>
</div>

<p><b>С возможностью выбора строк</b></p>
<div class="card">
  <div class="selection-info" *ngIf="selectedItems.length > 0">
    <p>Выбрано элементов: {{ selectedItems.length }}</p>
    <button class="p-button p-component" (click)="clearSelection()">Очистить выбор</button>
  </div>
  <pa-table
    [columns]="columns"
    [pagination]="pagination"
    [data]="products"
    [selectable]="true"
    (selectionChange)="onSelectionChange($event)"
  >
  </pa-table>
</div>

<p><b>С действиями для каждой строки</b></p>
<div class="card">
  <pa-table
    [columns]="columns"
    [data]="products"
    [pagination]="pagination"
    [actions]="tableActions"
    [actionsLabel]="'Действия'"
    (actionClick)="onActionClick($event)"
  >
  </pa-table>
</div>

<p><b>Комбинированная: с выбором и действиями</b></p>
<div class="card">
  <div class="selection-info" *ngIf="selectedItems.length > 0">
    <p>Выбрано элементов: {{ selectedItems.length }}</p>
    <button class="p-button p-component" (click)="clearSelection()">Очистить выбор</button>
  </div>
  <pa-table
    [columns]="columns"
    [data]="products"
    [pagination]="pagination"
    [selectable]="true"
    [actions]="tableActions"
    [actionsLabel]="'Действия'"
    (selectionChange)="onSelectionChange($event)"
    (actionClick)="onActionClick($event)"
  >
  </pa-table>
</div>

<p><b>С фиксированными заголовками</b></p>
<div class="card">
  <pa-table [columns]="stickyColumns" [data]="extendedProducts" [pagination]="pagination"> </pa-table>
</div>

<p><b>С фиксированными столбцами и заголовками</b></p>
<div class="card">
  <pa-table
    [columns]="stickyColumns"
    [data]="extendedProducts"
    [pagination]="pagination"
    [selectable]="true"
    [actions]="tableActions"
    [actionsLabel]="'Действия'"
    (selectionChange)="onSelectionChange($event)"
    (actionClick)="onActionClick($event)"
  >
  </pa-table>
</div>

<p><b>Только карточки</b></p>
<div class="card">
  <pa-table [columns]="columns" [pagination]="pagination" [data]="products"> </pa-table>
</div>

<p><b>Таблица с кликабельным временем (видеоархив)</b></p>
<div class="card">
  <pa-table [columns]="timeColumns" [data]="timeData" [pagination]="pagination"> </pa-table>
</div>

<p><b>С изображением и текстом в ячейках</b></p>
<div class="card">
  <pa-table 
    [columns]="imageTextColumns" 
    [data]="imageTextData"
    [pagination]="pagination"
    [striped]="true">
  </pa-table>
</div>

<p><b>С due_date и recurrent_period (тег при наведении)</b></p>
<div class="card">
  <pa-table 
    [columns]="dueDateColumns" 
    [data]="dueDateData"
    [pagination]="pagination">
  </pa-table>
</div>

<p><b>С изображениями и файлами</b></p>
<div class="card">
  <pa-table 
    [columns]="columnsWithImages" 
    [data]="productsWithImages"
    [pagination]="pagination">
  </pa-table>
</div>

<p><b>С группировкой</b></p>
<div class="card-grouped">
  <pa-table
    [columns]="groupedColumns"
    [data]="groupedProducts"
    [selectable]="true"
    [actions]="tableActions"
    [actionsLabel]="'Действия'"
    [groupBy]="groupByPaysMethod"
    (selectionChange)="onSelectionChange($event)"
    (actionClick)="onActionClick($event)"
  >
  </pa-table>
</div>